import { useMutation, useQueryClient } from '../lib/queryClient';
import { runConductor, InputType, OutputType } from '../endpoints/agents/conductor_POST.schema';

/**
 * Hook to run the Multi-Agent Conductor
 * Orchestrates Planner → Builder → Reviewer → QA loop
 */
export const useConductor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: InputType) => runConductor(params),
    onSuccess: (data) => {
      // Invalidate chat history to show the conductor summary
      queryClient.invalidateQueries({ queryKey: ['ai', 'history', data.sessionId] });
      // Invalidate files in case Builder made changes
      queryClient.invalidateQueries({ queryKey: ['files', 'list', data.sessionId] });
    },
  });
};

export type { InputType as ConductorInput, OutputType as ConductorOutput };
